import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductDetails } from './components/ProductDetails';
import { Offer } from './components/Offer';
import { FooterFAQ } from './components/FooterFAQ';
import { PurchasePopup } from './components/PurchasePopup';
const META_PIXEL_ID = '2069197916973057';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel and fire PageView using official snippet
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
      return;
    }
    /* eslint-disable */
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-cream font-body selection:bg-brand-orange selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <ProblemAgitation data-id="element-3" />
      <ProductDetails data-id="element-4" />
      <Offer data-id="element-5" />
      <FooterFAQ data-id="element-6" />
      <PurchasePopup data-id="element-7" />
    </div>;
}